import { getGetProductChannelList } from "../../request/ucenterapi/ucenterapi/uc/internal/dict/getProductChannelList/get.js";
import { getUnifySelectAttrValue } from "../../utils/getUnifySelectData.js";
function standardGetSoftOutfitListData(unifySelectInventory, userInfo) {
  return unifySelectInventory.map((item) => {
    var _a;
    const list = {
      packageType: ((_a = item.paramConfig) == null ? void 0 : _a.packageType) || getUnifySelectAttrValue(item, "packageType") || "",
      commodityParam: item.commodityParam,
      productDetailId: item.baseInfo.productId,
      name: item.commodityName || "",
      id: item.commodityId || "",
      commodityId: item.commodityId || "",
      no: item.no || "",
      quantity: item.quantity || "",
      brand: item.baseInfo.applicableBrandCategorys.length > 0 ? item.baseInfo.applicableBrandCategorys[0]["brand"] : "brand_oppein",
      businessTypeId: item.baseInfo.businessTypeId || "",
      category: item.baseInfo.applicableBrandCategorys.length > 0 ? item.baseInfo.applicableBrandCategorys[0]["category"] : "category_qiangshi",
      creatorId: item.baseInfo.creatorId || "",
      deleted: item.baseInfo.deleted || "",
      isOut: item.baseInfo.isOut || "0",
      orgId: item.baseInfo.orgId,
      orgType: item.baseInfo.orgType,
      originalId: item.baseInfo.originalId,
      pid: item.baseInfo.pid || "",
      price: item.baseInfo.standardPrice || "",
      productAttribute: item.baseInfo.productAttribute || "",
      productChannel: item.baseInfo.applicableProductChannels.join(","),
      productionCycle: item.baseInfo.productionCycle || "",
      lineNo: item.lineNo || "",
      productionIds: item.items || [],
      creator: userInfo.userName,
      createDt: new Date().getTime(),
      lastUpdator: userInfo.userName,
      lastUpdateDt: new Date().getTime(),
      productionMode: item.baseInfo.productionMode,
      extraFields: JSON.stringify(item.paramConfig),
      standard: item.paramConfig ? item.paramConfig.isNonStand : void 0,
      remark: item.paramConfig ? item.paramConfig.editRemark || "" : "",
      packageId: item.items ? item.commodityId : "",
      isPackage: item.items ? 1 : 0,
      productId: item.commodityId || ""
    };
    item.attributes && item.attributes.forEach((items) => {
      list[items.attributeCode] = items.attributeValues && items.attributeValues.length > 0 ? items.attributeValues[0] : "";
    });
    item.editableAttributeValue && item.editableAttributeValue.forEach((eitem) => {
      list[eitem.attributeCode] = eitem.attributeValues && eitem.attributeValues.length > 0 ? eitem.attributeValues[0] : "";
    });
    if (list.productionIds.length > 0) {
      list.productionIds.forEach((litem) => {
        litem.attributes.forEach((litems) => {
          litem[litems.attributeCode] = litems.attributeValues && litems.attributeValues.length > 0 ? litems.attributeValues[0] : "";
        });
      });
    }
    if (item.paramConfig)
      list.extraFields = JSON.stringify(item.paramConfig);
    return list;
  });
}
function getFirstFloorSaveData(cur) {
  return {
    commodityParam: cur.commodityParam,
    name: cur.name,
    productDetailId: cur.productDetailId,
    faucetModel: cur.faucetModel || "",
    packagetype: cur.packageType || "",
    installationMode: cur.installationMode || "",
    isNonStand: cur.isNonStand || 0,
    isSelectFaucet: cur.isSelectFaucet,
    model: cur.model,
    classify1: cur.classify1,
    productId: cur.id || "",
    price: +cur.price || 0,
    specification: cur.specification || "",
    quantity: +cur.quantity,
    remark: cur.remark,
    unionCode: cur.no || "",
    salesCode: cur.salesCode || "",
    isPackage: cur.isPackage || 0,
    EXfaucetModel: cur.faucetModel || "",
    standard: cur.isNonStand || 0,
    lineNo: cur.lineNo || "",
    packageId: cur.isPackage ? cur.id : "",
    packageSize: cur.isPackage ? cur.quantity : "",
    extraFields: cur.extraFields,
    productionMode: cur.productionMode
  };
}
function standardGetSaveList(softOutfitListData) {
  const saveList = [];
  softOutfitListData.forEach((cur) => {
    if (cur.lineNo && cur.productionIds.length > 0) {
      saveList.push(getFirstFloorSaveData(cur));
      cur.productionIds.forEach((item) => {
        saveList.push({
          commodityParam: cur.commodityParam,
          name: item.commodityName || "",
          productDetailId: cur.productDetailId,
          productId: item.commodityId || "",
          specification: item.specification || "",
          quantity: +item.quantity,
          remark: item.paramConfig ? item.paramConfig.editRemark || "" : "",
          unionCode: item.no || "",
          faucetModel: item.faucetModel || "",
          installationMode: item.installationMode || "",
          isNonStand: cur.isNonStand || 0,
          isSelectFaucet: cur.isSelectFaucet,
          model: cur.model,
          classify1: cur.classify1,
          packagetype: item.packageType || "",
          price: +cur.price || 0,
          salesCode: cur.salesCode || "",
          isPackage: cur.lineNo ? 1 : 0,
          standard: cur.isNonStand || 0,
          lineNo: cur.lineNo,
          packageId: cur.id,
          packageSize: cur.quantity,
          extraFields: JSON.stringify(item.paramConfig),
          productionMode: cur.productionMode
        });
      });
    } else {
      saveList.push(getFirstFloorSaveData(cur));
    }
  });
  return [saveList];
}
function transFormInventory(inventory, userInfo) {
  const softOutfitListData = standardGetSoftOutfitListData(inventory, userInfo);
  const [saveList] = standardGetSaveList(softOutfitListData);
  return saveList.map((item) => {
    return {
      packageType: item.packagetype,
      commodityParam: item.commodityParam,
      productId: item.productId,
      name: item.name,
      code: item.unionCode,
      quantity: item.quantity,
      detailType: "\u6807\u51C6\u54C1",
      source: "\u7EDF\u4E00\u9009\u62E9",
      secondaryType: "",
      remark: item.remark,
      price: item.price,
      settlePrice: "",
      specification: item.specification,
      standard: item.standard,
      faucetModel: item.faucetModel,
      unionCode: item.unionCode,
      salesCode: item.salesCode,
      lineNo: item.lineNo,
      isPackage: item.isPackage,
      packageId: item.packageId,
      packageSize: item.packageSize,
      productionMode: item.productionMode,
      extraFields: item.extraFields
    };
  });
}
async function getStandardProductChannelOptions({
  applicableProductChannels,
  getProductChannelList,
  baseInfoApplicableProductChannels
}) {
  const innerGetProductChannelList = getProductChannelList || getGetProductChannelList;
  const { data: allOptions } = await innerGetProductChannelList();
  const filterOptions = Array.isArray(applicableProductChannels) ? allOptions.filter(({ productChannelCode }) => applicableProductChannels.includes(productChannelCode)) : allOptions;
  if (baseInfoApplicableProductChannels) {
    return filterOptions.filter(({ productChannelCode }) => baseInfoApplicableProductChannels.includes(productChannelCode));
  } else {
    return [];
  }
}
export { getStandardProductChannelOptions, transFormInventory };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/business/unifySelectInventory/unifySelectInventory.js